module.exports = __webpack_public_path__ + "static/media/signin.fd68abb2.png";